import { getMaster, delMaster } from "utils/api";

export const getRoleList = async (params) => {
  return await getMaster("/roles", {
    sort: "id,asc",
    ...params,
  });
};

export const updateStatus = async (params) => {
  const { roleId, ...rest } = params;
  return await putOperation(`/roles/${roleId}`, {
    ...rest,
  });
};

export const deleteRole = async (roleId) => {
  return await delMaster("/roles/" + roleId, {});
};
